module.exports = __webpack_public_path__ + "assets/admin.dbea8db5.svg";